let wishlistItemTemplate = `
<div class="wishlist-item" data-id="{id}" data-line-quantity="1">
  <div class="wishlist-item__container">
    <div class="wishlist-item__image"><a href="{url}">
        <img width="140" src="{image}" class="wishlist-item__image">
      </a>
    </div>
    <div class="wishlist-item__content">
      <div class="wishlist-item__title mb-16">
        <a class="miller italic normal-text" href="{url}">{title}</a>
        <span class="miller small-text italic block">{tag}</span>
      </div>
      <div class="wishlist-item__price miller italic normal-text mb-16">
        {price}
      </div>
      <button data-id="{id}" class="wishlist-item__remove small-text secondary-color" data-product-id="{id}" data-product-json="{json}">
        Supprimer
      </button>
    </div>
  </div>
</div>
`;

class Wishlist extends HTMLElement {
  constructor() {
    super();

    this.initScreenVar();
    this.initEvents();
    window.addEventListener("resize", this.initScreenVar);
    this.metafield_id = "";
  }

  initScreenVar() {
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight / 100}px`
    );
  }

  initEvents() {
    document
      .querySelector('[data-modal="wishlist"]')
      .addEventListener("click", this.toggleWishlist.bind(this));
    this.querySelector(".wishlist__close").addEventListener(
      "click",
      this.toggleWishlist.bind(this)
    );

    document
      .querySelectorAll('.add-to-wishlist:not([data-wishlist-customer="false"]')
      .forEach((button) => {
        button.addEventListener("click", this.addToWishlist.bind(this));
      });

    // check if click outside of wishlist
    document.addEventListener("click", (e) => {
      if (
        e.target.closest(".wishlist") === null &&
        e.target.closest('[data-modal="wishlist"]') === null &&
        e.target.closest('[data-wishlist-customer="false"]') === null
      ) {
        this.classList.remove("open");
        document.querySelector("body").classList.remove("shadow-wishlist");
      }
    });

    let buttonNoLogged = document.querySelector(
      '[data-wishlist-customer="false"]'
    );

    if (buttonNoLogged) {
      buttonNoLogged.addEventListener("click", this.openWishlist.bind(this));
    }

    this.initRemoveEvents();
  }

  initRemoveEvents() {
    this.querySelectorAll(".wishlist-item__remove").forEach((button) => {
      if (button.dataset.listener === "true") return;
      button.addEventListener("click", this.removeWishlistProduct.bind(this));
    });
  }

  removeWishlistProduct(e) {
    let id = e.currentTarget.getAttribute("data-id");
    e.currentTarget.closest(".wishlist-item").classList.add("removed");
    this.addToWishlist(e);
  }

  toggleWishlist() {
    this.classList.toggle("open");
    if (document.querySelector("body").classList.contains("shadow-wishlist")) {
      document.querySelector("body").classList.remove("shadow-wishlist");
    } else {
      document.querySelector("body").classList.add("shadow-wishlist");
    }
  }

  openWishlist() {
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-wishlist");
  }

  updateWishlist(data) {
    console.log(data);
    let is_empty = data.products.length === 0;

    is_empty
      ? this.classList.add("wishlist--empty")
      : this.classList.remove("wishlist--empty");

    this.querySelector(".wishlist-contents__items").innerHTML = "";

    for (const item of data.products) {
      let html = "";
      let tag = "";

      for (const t of item.tags) {
        if (t.indexOf("metal:") > -1) {
          tag = t.replace("metal:", "");
        } else if (t.indexOf("modele:") > -1) {
          tag = t.replace("modele:", "");
        } else if (t.indexOf("pierre:") > -1) {
          tag = t.replace("pierre:", "");
        }
      }

      html = wishlistItemTemplate
        .replaceAll("{url}", item.url)
        .replace("{tag}", tag)
        .replace("{image}", item.featured_image)
        .replace("{title}", item.title)
        .replace("{price}", item.price / 100 + " €")
        .replace("{json}", JSON.stringify(item).replaceAll('"', "'"))
        .replaceAll("{id}", item.id);
      this.querySelector(".wishlist-contents__items").innerHTML += html;
    }

    this.initRemoveEvents();

    /** Check all items to remove **/
    let items = this.querySelectorAll(".wishlist-item");
    let removed = false;

    if (data.token) {
      for (const item of items) {
        if (item.classList.contains("removed")) {
          removed = true;
          item.remove();
        }
      }
    }

    items = this.querySelectorAll(".wishlist-item");

    document.querySelector(
      "[data-wishlist-count]"
    ).innerHTML = `(${items.length})`;
    if (items.length > 0) {
      document
        .querySelector("[data-wishlist-count]")
        .classList.remove("hidden");
      document.querySelector("[data-wishlist-empty]").classList.add("hidden");
      document.querySelector("[data-wishlist-full]").classList.remove("hidden");
    } else {
      document.querySelector("[data-wishlist-count]").classList.add("hidden");
      document
        .querySelector("[data-wishlist-empty]")
        .classList.remove("hidden");
      document.querySelector("[data-wishlist-full]").classList.add("hidden");
    }
    removed = document.querySelector(
      '[data-action="add-wishlist"][data-wishlist="true"]'
    )
      ? false
      : true;
    if (!removed) this.openWishlist();
  }

  async getUserById(id) {
    await fetch(
      "https://vygzi07aq0.execute-api.eu-west-3.amazonaws.com/dev/customers/" +
        id +
        "/metafields",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        data.metafields.forEach((element) => {
          if (element.key == "wishlist_json") {
            return (this.metafield_id = element.id);
          }
        });
      })
      .catch((error) => {});
  }

  async addToWishlist(e) {
    console.log(e.currentTarget.dataset.productJson);
    let item = JSON.parse(
      e.currentTarget.dataset.productJson.replaceAll("'", '"')
    );
    console.log(e.currentTarget);

    window.WISHLIST = await this.fetchWishlist(item);
    console.log(e.currentTarget);

    if (window.WISHLIST.products === undefined) {
      window.WISHLIST = {};
      window.WISHLIST.products = [];
    }

    let already_exists = false;

    for (const product of window.WISHLIST.products) {
      if (product.id == item.id) {
        already_exists = true;
      }
    }

    let button = document.querySelector(
      '[data-action="add-wishlist"][data-product-id="' + item.id + '"]'
    );
    if (button) {
      button.dataset.wishlist = !already_exists;
    }

    console.log(item);

    if (!already_exists) {
      window.WISHLIST.products.push({
        title: item.title,
        id: item.id,
        handle: item.handle,
        price: item.price,
        tags: item.tags,
        url: `/products/${item.handle}`,
        featured_image: item.featured_image,
      });
    } else {
      window.WISHLIST.products = window.WISHLIST.products.filter(
        (product) => product.id != item.id
      );
    }

    console.log(window.WISHLIST.products);

    await fetch(
      "https://mem72unxg6.execute-api.eu-west-3.amazonaws.com/prod/customers/" +
        window.CUSTOMER_ID +
        "/wishlist",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(window.WISHLIST),
      }
    )
      .then((response) => response.json())

      .then((data) => {
        console.log("Success:", data);
        this.updateWishlist(JSON.parse(data.metafield.value));
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async fetchWishlist() {
    return await fetch("/account?view=wishlist-json", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        return data;
      });
  }

  // fetchUpdateCart(id, quantity) {
  //     var url = "/cart/update.js";
  //     const update_label = "updates[" + id + "]=" + quantity;
  //     const body = update_label;

  //     fetch(url, {
  //         method: "post",
  //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //         body: body,
  //     })
  //         .then((response) => {
  //             return response.json();
  //         })
  //         .then((data) => {
  //             this.refreshCart(data);
  //         })
  //         .catch(() => { });
  // }
}

customElements.define("wish-list", Wishlist);
